import classNames from 'classnames/bind';
import React from 'react';

import styles from './common.module.scss';

import { FieldNumber } from '@/components/ui/kit/Field';

const cx = classNames.bind(styles);

const Item = ({ data: command }) => {
  return (
    <div className={cx('container')}>
      <label>
        Relay Instance Number
        <div className={cx('fieldWrapper')}>
          <FieldNumber value={command.data.relay} readOnly />
          <span className={cx('unit')} />
        </div>
      </label>
      <label>
        Cycle Count
        <div className={cx('fieldWrapper')}>
          <FieldNumber value={command.data.count} readOnly />
          <span className={cx('unit')} />
        </div>
      </label>
      <label>
        Cycle Time
        <div className={cx('fieldWrapper')}>
          <FieldNumber value={command.data.time} readOnly />
          <span className={cx('unit')}>secs</span>
        </div>
      </label>
    </div>
  );
};

export default Item;
